import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Notifications } from "../interfaces/notifications.interface";
import { AuthenticationService } from "./auth.service";

@Injectable({
  providedIn: "root"
})
export class ApiServiceNotifications {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  private optionsHeader = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: this.authenticationService.getBearerToken()
    })
  };

  getAllNotifications() {
    return this.http.get<Notifications>("/notifications", this.optionsHeader);
  }

  deleteNotifications(id: string) {
    return this.http.delete<unknown>(`/notifications/${id}`, this.optionsHeader);
  }

  updateStatusNotifications(id: string) {
    return this.http.put<unknown>(`/notifications/${id}`, this.optionsHeader);
  }
}
